module.exports = __webpack_public_path__ + "img/link.c71cff0c.svg";